import React, {Fragment, useEffect, useRef, useState} from 'react'
import axios, * as others from 'axios';
import {useLoaderData, useLocation, useParams} from "react-router-dom";
import {
    addEventAttribute,
    adminEventCard,
    audienceButtons,
    changeAttribute,
    eventHeaderCard,
    eventHeroCard,
    getAttribute,
    getImageWithPrefix,
    getLocalDate,
    getLocalDateForEvent,
    hasAttribute,
    inheritAudiences,
    mergeEvents,
    mergeEventsCard,
    MetaTags,
    setAttribute,
    setRoomAttribute,
    setUniqueAttractionAttribute,
    setUniqueEventAttribute,
    smallArtistCard,
    smallEventCard,
    smallVenueCard,
    spinner,
    spotifyPlayer,
    toastSuccess,
    trackPageView,
    workingWithCard,
    workingWithCardPlusEdit
} from "../../components/common/utilities";
import moment from "moment";
import 'moment/locale/en-gb';
import {XMarkIcon} from "@heroicons/react/24/outline";
import {SchemaEvent} from "../../components/common/dataTypes";
import PromoteEvent from "../../components/common/promoteEvent";
import {Dialog, Field, Label, Switch, Transition} from "@headlessui/react";
import {ToastContainer} from "react-toastify";
import {Footer, Header} from "../../components/common/headerAndFooter";
import PromoteEventForUser from "../../components/common/promoteEventLoggedIn";
import PromoteEventSpecial from "../../components/common/promoteEventSpecial";


function classNames(...classes: any[])
{
    return classes.filter(Boolean).join(' ')
}

export default function ViewEvent() {
    let params = useParams();
    const venueID = params.venueID;
    const data = useLoaderData() as any;

    // console.log("params", params);

    const text = useRef("");
    const inFocus = useRef("");
    const [artists, setArtists] = useState();
    const [duplicates, setDuplicates] = useState([]);
    let [loading, setLoading] = useState(true);
    let [color, setColor] = useState("#ffffff");
    const [date, setDate] = useState(null)
    const [eventData, setEventData] = useState<SchemaEvent>();
    const [showMedia, setShowMedia] = useState(false);
    const [artistSearch, setArtistSearch] = useState(false);
    const [venueSearch, setVenueSearch] = useState(false);
    const [offers, setOffers] = useState([]);
    const [showDescriptions, setShowDescriptions] = useState(false);

    const [wholeDay, setWholeDay] = useState(false);
    const [isPrivate, setIsPrivate] = useState(false);
    const [lang, setLang] = useState(getLang());
    const [open, setOpen] = useState(false);
    const [showDetail, setShowDetail] = useState(true);
    const [showSpecial, setShowSpecial] = useState(false);

    function getLang()
    {
        const userlang = localStorage.getItem('userlang');
        if (userlang)
        {
            return userlang;
        }
        if (navigator.languages != undefined) return navigator.languages[0].split('-')[0];
        return navigator.language.split('-')[0];
    }

    let adBtnGroupClasses = classNames('relative inline-flex items-center rounded-l-md px-3 py-2 text-sm font-semibold ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-10', {});

    const getEvent = () => {

        const now = new Date();

        let parameters = {

        };


        axios.get(`${process.env.REACT_APP_CLOUDAPI_URL}/v1/event/`+params.eventID+`/`+lang, {
            params: parameters

        }).then(function (response) {
            // handle success
            //console.log(response);
            setEventData(response.data)
            if (response.data.performers)
            {
                setArtists(response.data.performers);
            }
            if (response.data.gogo && response.data.gogo.wholeDay)
            {
                setWholeDay(response.data.gogo.wholeDay);
            }
            if (response.data.admin && response.data.admin.isprivate)
            {
                setIsPrivate(response.data.admin.isprivate);
            }
            if (response.data.offers)
            {
                let offer = null;
                if (Array.isArray(response.data.offers)) {
                    console.log("It's a list of objects:", response.data.offers);
                    offer = response.data.offers[0];
                    setOffers(response.data.offers);


                } else if (typeof response.data.offers === 'object' && response.data.offers !== null) {
                    console.log("It's a single object:", response.data.offers);
                    setOffers(response.data.offers);
                    offer = response.data.offers;

                } else {
                    console.log("It's something else:", response.data.offers);
                }

                console.log("offer", offer.price);
                //console.log("offer", offer.price);
                if(response.data.location && response.data.location.gogo && response.data.location.gogo.tier && response.data.location.gogo.tier === 5)
                {
                    setShowSpecial(true);
                }
                else if(offer.price && offer.price < 5000)
                {
                    setShowSpecial(true);
                }
                else if (!offer.price)
                {
                    if(offer.lowPrice && offer.lowPrice < 5000)
                    {
                        setShowSpecial(true);
                    }
                    else if (offer.lowPrice && offer.lowPrice > 4999)
                    {
                        setShowSpecial(false);
                    }
                    else {
                        setShowSpecial(true);
                    }

                }


            }
            else {
                setShowSpecial(true);
            }

            trackPageView("EDP: "+response.data.name, response.data.image);


        }).catch(function (error) {
            // handle error
            console.log(error);
            //window.location.href = '/dashboard';
        });
    }

    const getEvents = (nextOffset: any) => {
        axios.get(`${process.env.REACT_APP_API_URL}/p/events/upcoming.do`, {
            params: {
                instance: 'promogogo', ticket: localStorage.getItem('ticket'), //guid: params.id,
                limit: 10, offset: nextOffset, artist: params.id, lang: "is"
            }

        }).then(function (response) {
            // handle success
            console.log("events", response);
            //setRooms(response.data.collection);

        });
    }
    const getDuplicates = async () => {
        axios.post(`${process.env.REACT_APP_API_URL}/p/manage/event/duplicates.do`, {
            ticket: localStorage.getItem('ticket'), event: params.eventid,
        }, {
                       headers: {
                           'Content-Type': 'application/x-www-form-urlencoded'
                       }
                   }).then(function (response) {
            // handle success
            console.log(response);
            if (response.data.collection && response.data.collection.length > 1)
            {
                setDuplicates(response.data.collection);
            }

        });
    }

    const toggleMedia = () => {
        if (showMedia)
        {
            setShowMedia(false);
        }
        else
        {
            setShowMedia(true);
        }
    }

    const searchVenues = () => {
        setOpen(true);
        setVenueSearch(true);
        setArtistSearch(false);
        setShowDescriptions(false);

    }

    const searchAttractions = () => {
        setOpen(true);
        setVenueSearch(false);
        setArtistSearch(true);
        setShowDescriptions(false);

    }

    const editDescriptions = () => {
        setOpen(true);
        setVenueSearch(false);
        setArtistSearch(false);
        setShowDescriptions(true);
    }


    useEffect(() => {

        getEvent();
        //getDuplicates();
        //getPhotos();
        //handleArtists(data);

    }, []);


    const pagedata = useLoaderData() as any;
    let faceguid = '';

    // @ts-ignore
    function clickedEvent(e)
    {


    }


    return (

        <div className="min-h-full dark:bg-white bg-white">
            {eventData && <MetaTags
                    title={eventData.name + ' | Gjugg - allir viðburðir'}
                    description={"upplýsingar um " + eventData.name + " @ " + eventData.location.name}
                    image={eventData.image && eventData.image}/>}


            <div className="bg-pg_blue">
                <Header/>
                {!eventData && <div className={'bg-white rounded-lg mt-2 p-4'}>{spinner()}</div>}

                {eventData && (
                    <main className="bg-pg_blue">
                        <div className="mx-auto max-w-7xl px-4 py-4 sm:px-6 sm:py-6 lg:px-8">
                            <div className="overflow-hidden rounded-xl bg-white shadow-sm ring-1 ring-gray-900/5">


                                <div className="grid grid-cols-1 divide-y divide-gray-200 lg:grid-cols-3 lg:divide-x lg:divide-y-0">

                                    {/* LEFT COLUMN — event info */}
                                    <div className="min-w-0 space-y-8 p-5 sm:p-6 lg:col-span-2">
                                        {eventHeroCard(eventData)}
                                        {eventData.description && (
                                            <div
                                                className="prose prose-base max-w-none break-words text-gray-700 lg:prose-lg"
                                                dangerouslySetInnerHTML={{ __html: eventData.description }}
                                            />
                                        )}

                                        <div className="space-y-3">
                                            {eventData.url && (
                                                <a
                                                    href={eventData.url}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-pg_blue px-4 py-2.5 text-base font-semibold text-white shadow-sm transition-colors hover:bg-pg_pink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pg_blue"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth={1.5}
                                                        stroke="currentColor"
                                                        className="h-5 w-5"
                                                        aria-hidden="true"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
                                                        />
                                                    </svg>
                                                    Meiri upplýsingar
                                                </a>
                                            )}

                                            {eventData.offers && eventData.offers.map((offer: any, index: number) => (
                                                <a
                                                    key={offer.url || index}
                                                    href={offer.url}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-pg_green px-4 py-2.5 text-base font-semibold text-white shadow-sm transition-colors hover:bg-pg_pink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pg_green"
                                                >
                                                    <svg
                                                        xmlns="http://www.w3.org/2000/svg"
                                                        fill="none"
                                                        viewBox="0 0 24 24"
                                                        strokeWidth={1.5}
                                                        stroke="currentColor"
                                                        className="h-5 w-5"
                                                        aria-hidden="true"
                                                    >
                                                        <path
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                            d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z"
                                                        />
                                                    </svg>
                                                    Finna miða
                                                </a>
                                            ))}
                                        </div>

                                        {eventData.performers && eventData.performers.length > 0 && (
                                            <section aria-labelledby="performers-heading">
                                                <h2
                                                    id="performers-heading"
                                                    className="text-base font-bold text-pg_blue sm:text-lg"
                                                >
                                                    Aðilar tengdir viðburðinum
                                                </h2>
                                                <div className="mt-3 space-y-3">
                                                    {eventData.performers.map((artist: any, index: number) => (
                                                        <React.Fragment key={artist['@id'] || index}>
                                                            {workingWithCard(artist)}
                                                            {index === 0 && (
                                                                <div className="mt-2">{spotifyPlayer(artist)}</div>
                                                            )}
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </section>
                                        )}

                                        {eventData.location && (
                                            <section aria-labelledby="venue-heading">
                                                <h2
                                                    id="venue-heading"
                                                    className="text-base font-bold text-pg_blue sm:text-lg"
                                                >
                                                    Hvar er viðburðurinn haldinn
                                                </h2>
                                                <div className="mt-3">{smallVenueCard(eventData.location)}</div>
                                            </section>
                                        )}
                                    </div>

                                    {/* RIGHT COLUMN — advertising */}
                                    <div className="min-w-0 bg-gray-50 p-5 sm:p-6 lg:col-span-1 lg:p-4">
                                        <section className="space-y-3">
                                            <p className="text-base leading-relaxed text-gray-700">
                                                <span className="font-semibold text-gray-900">Auglýsingapakkarnir </span>
                                                sjá til þess að viðburðurinn birtist á forsíðu Vísis í fjólubláa
                                                viðburðakassanum, sem og á Lífinu og undirsíðum þess.
                                            </p>

                                            <img
                                                className="aspect-video w-full rounded-lg object-cover ring-1 ring-gray-900/5"
                                                src="https://promogogo.com/cdn-cgi/image/width=720,fit=cover/https://media.promogogo.com/ymsirvidburdir/2025-04-15/143933eba6514c7799644a49859d6674.png"
                                                alt=""
                                            />

                                            <p className="text-base leading-relaxed text-gray-700">
                                                <span className="font-semibold text-gray-900">Verð pakkans </span>
                                                miðast við umfang viðburðarins, miðaverð, stærð hússins ofl. svo við getum
                                                boðið upp á bestu mögulegu þjónustu.
                                            </p>

                                            {showSpecial ? (
                                                <PromoteEventSpecial event={eventData} />
                                            ) : (
                                                 <PromoteEvent event={eventData} />
                                             )}

                                            <a
                                                href={`https://visir.is/vidburdir?event=${params.eventID}#event/`}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-pg_blue px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-pg_pink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pg_blue"
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="none"
                                                    viewBox="0 0 24 24"
                                                    strokeWidth={1.5}
                                                    stroke="currentColor"
                                                    className="h-4 w-4"
                                                    aria-hidden="true"
                                                >
                                                    <path
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                        d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                                                    />
                                                </svg>
                                                Sjá á Vísi
                                            </a>
                                        </section>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </main>
                )}
                <Footer/>
            </div>
            <ToastContainer autoClose={800} theme={'dark'}/>

        </div>)
}
